import template from './dataGrid.html';

class DataGridController {
    constructor() {
        this.shouldDisplayActions = this.actions && this.actions.length > 0;
        // this.datastore = this.datastore();
    }

    btnClicked(btnId, params) {
        this.onBtnClick({btnId: btnId, params: params});
    }

    edit(item) {
        this.onEdit({item: item});
    }

    delete(item) {
        this.onDelete({item: item});
    }
}

DataGridController.$inject = ['$q'];

const DataGridComponent = {
        restrict: 'E',
        templateUrl: template,
        bindings: {
            fields: '<',
            entries: '<',
            entity: '<',
            datastore: '&',
            actions: '<',
            onBtnClick: '&',
            onEdit: '&',
            onDelete: '&',
            tblClass: '@'
        },
        controller: DataGridController,
        controllerAs: 'vm'
};

export {DataGridComponent};



// WEBPACK FOOTER //
// ./app/components/common/crud/list/dataGrid.component.js